export const CREATED = 'created'
export const RECEIVED = 'received'
export const ENLISTMENT = 'enlistment'
export const DISPATCHED = 'dispatched'
export const CANCELLED = 'cancelled'
export const FINALIZED = 'finalized'
export const PAYMENT = 'payment'
export const PAYMENT_SUCCESS = 'payment_success'
export const PAYMENT_ERROR = 'payment_error'
